<div class="dialog">
    <div class="dialog-title">
        <h6 class="pl-3">Edit Batch Timeline <img src="assets/svg/close-white.svg" alt="close" (click)="close()"></h6>
    </div>
    <div class="content m-0 p-0 rounded">
        <form [formGroup]="stageUpdateForm" class="w-100">
            <div class="row py-2 px-1 m-4 border rounded">
                <div class="col-md-4 d-flex align-items-center gap-1">
                    <div class="thumbnail no-padding mb-2"
                        *ngIf="!partDetails.model_attributes.file_name.includes('.pdf')">
                        <img class="pointer" [src]="partDetails.thumbnail" alt="Part Image">
                    </div>
                    <div class="value text-dark fw-bold d-flex flex-column">
                        <span>{{ partDetails?.model_attributes?.file_name || '--' }}</span>
                        <span>Batch {{batchNumber}}</span>
                    </div>
                </div>
                <div class="col-md-2">
                    <label>Quantity</label>
                    <div class="value text-dark fw-bold">{{batchDetails?.dispatch_quantity ||'--'}}</div>
                </div>
                <div class="col-md-3">
                    <label>Committed Delivery Date</label>
                    <div class="value text-dark fw-bold">{{batchDetails?.dispatch_date || '18/03/2024' |
                        date:'longDate'}}</div>
                </div>
                <div class="col-md-3">
                    <label>Expected Delivery Date</label>
                    <div class="value text-dark fw-bold">{{batchDetails?.revised_deadline ||
                        batchDetails?.dispatch_date |
                        date:'longDate'}}</div>
                </div>


                <div class="col-md-12 d-flex flex-row justify-content-between py-2">
                    <div>
                        <label>Raw Materials</label>
                        <div class="date-picker  row mr-0 ml-0">
                            <input [disabled]="hasStagePassed('RM Available')" type="text" matInput
                                formControlName="rawMaterials" [matDatepicker]="rawMaterialPicker">
                            <mat-datepicker-toggle class="icon" matSuffix
                                [for]="rawMaterialPicker"></mat-datepicker-toggle>
                            <mat-datepicker [disabled]="hasStagePassed('RM Available')" #rawMaterialPicker></mat-datepicker>
                        </div>
                    </div>
                    <div>
                        <label>Manufacturing</label>
                        <div class="date-picker  row mr-0 ml-0">
                            <input [disabled]="hasStagePassed('Manufacturing')" type="text" matInput
                                formControlName="manufacturing" [matDatepicker]="manufacturingPicker">
                            <mat-datepicker-toggle class="icon" matSuffix
                                [for]="manufacturingPicker"></mat-datepicker-toggle>
                            <mat-datepicker #manufacturingPicker></mat-datepicker>
                        </div>
                    </div>
                    <div>
                        <label>Painting</label>
                        <div class="date-picker  row mr-0 ml-0">
                            <input [disabled]="hasStagePassed('Painting')" type="text" matInput
                                formControlName="painting" [matDatepicker]="paintingPicker">
                            <mat-datepicker-toggle class="icon" matSuffix
                                [for]="paintingPicker"></mat-datepicker-toggle>
                            <mat-datepicker #paintingPicker></mat-datepicker>
                        </div>
                    </div>
                    <div>
                        <label>Inspection</label>
                        <div class="date-picker  row mr-0 ml-0">
                            <input [disabled]="hasStagePassed('Inspection')" type="text" matInput
                                formControlName="inspection" [matDatepicker]="inspectionPicker">
                            <mat-datepicker-toggle class="icon" matSuffix
                                [for]="inspectionPicker"></mat-datepicker-toggle>
                            <mat-datepicker #inspectionPicker></mat-datepicker>
                        </div>
                    </div>
                    <div>
                        <label>Inventory</label>
                        <div class="date-picker  row mr-0 ml-0">
                            <input [disabled]="hasStagePassed('Inventory')" type="text" matInput
                                formControlName="inventory" [matDatepicker]="inventoryPicker">
                            <mat-datepicker-toggle class="icon" matSuffix
                                [for]="inventoryPicker"></mat-datepicker-toggle>
                            <mat-datepicker #inventoryPicker></mat-datepicker>
                        </div>
                    </div>
                    <div>
                        <label>Shipping</label>
                        <div class="date-picker  row mr-0 ml-0">
                            <input [disabled]="hasStagePassed('Shipping')" type="text" matInput
                                formControlName="shipping" [matDatepicker]="shippingPicker">
                            <mat-datepicker-toggle class="icon" matSuffix
                                [for]="shippingPicker"></mat-datepicker-toggle>
                            <mat-datepicker #shippingPicker></mat-datepicker>
                        </div>
                    </div>
                    <div>
                        <label>Delivery</label>
                        <div class="date-picker  row mr-0 ml-0">
                            <input [disabled]="hasStagePassed('Delivered')" type="text" matInput
                                formControlName="delivery" [matDatepicker]="deliveryPicker">
                            <mat-datepicker-toggle class="icon" matSuffix
                                [for]="deliveryPicker"></mat-datepicker-toggle>
                            <mat-datepicker #deliveryPicker></mat-datepicker>
                        </div>
                    </div>
                </div>

            </div>

            <div class="col-md-12 d-flex flex-column">
                <label class="col-12">Reason for Date Change</label>
                <textarea class="mx-2 mb-3" style="height: 150px;" type="textarea"
                    formControlName="reason_for_datechange" placeholder="Enter"
                    aria-label="Reason for date change"></textarea>

            </div>
        </form>


        <!-- <div class="row py-2 px-1 m-4 border rounded">
            <form class="container-fluid pt-0 row mb-4 mx-0" [formGroup]="demoForm" validate>
                <div class="col-12 mt-4" *ngIf="demoForm.get('affected_deadline').value === 'yes'"><label>Select
                        Deadline
                        Date</label>
                    <div class="date-picker  row mr-0 ml-0">
                        <input type="text" [value]="revised_deadline"
                            (dateChange)="revisedDatePickerHandler($event.target.value)" matInput
                            [matDatepicker]="revisedDatePicker">
                        <mat-datepicker-toggle class="icon" matSuffix [for]="revisedDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #revisedDatePicker></mat-datepicker>
                    </div>
                </div>

            </form>
        </div> -->

    </div>
    <div class="footer row container-fluid pr-0">
        <div class="col-md-6">

        </div>
        <div class="col-md-6 d-flex button">
            <button class="white mr-2" (click)="close()">Cancel</button>
            <button class="orange ml-2" (click)="submitForm()">Submit</button>
        </div>

    </div>
</div>